import { Shimmer, Card } from '@soteria/design-system-ve';

import * as shimmerStyles from '../shared/shimmer.css';

import * as styles from './AuditItemSection.css';

/**
 * Data-only shimmer component for when filters change or pagination loads
 * This only covers the data list area, keeping filters interactive
 */
export function DataListShimmer() {
  return (
    <div className={styles.auditItemsList}>
      {/* Render 3 accurate shimmer audit items */}
      {[1, 2, 3].map(index => (
        <Card key={`data-shimmer-${index}`} className={shimmerStyles.shimmerCard}>
          <div className={shimmerStyles.shimmerCardHeader}>
            <Shimmer className={shimmerStyles.shimmerBadge} />
            <Shimmer className={shimmerStyles.shimmerButton} />
          </div>
          <div className={shimmerStyles.shimmerCardContent}>
            <Shimmer className={shimmerStyles.shimmerContentBlock} />
            <Shimmer className={shimmerStyles.shimmerContentBlock} />
          </div>
          <div className={shimmerStyles.shimmerCardHeader}>
            <Shimmer className={shimmerStyles.shimmerButton} />
          </div>
        </Card>
      ))}
    </div>
  );
}
